import gql from 'graphql-tag'
import { CreateFloorInput, BMDialogFloor } from '@api'
import { BMDialogFloorFragment } from '@api/fragments'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createFloor: { floor: BMDialogFloor }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogFloor>({
  handler: (data) => data.createFloor.floor,
  name: 'Floor',
})

export default function create(
  input: CreateFloorInput & { building_id: string }
): Promise<BMDialogFloor> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation createFloor($input: CreateFloorInput!) {
    createFloor(input: $input) {
      floor {
        ...BMDialogFloorFragment
      }
    }
  }
  ${BMDialogFloorFragment}
`
